<div class="relative">
  @if (showActionItemBadge()) {
    <div
      class="absolute right-0 top-0 z-50 block aspect-square w-2.5 rounded-full bg-interface-positive-default"
    >
      <div
        class="absolute inset-0 animate-ping rounded-full bg-interface-positive-default"
      ></div>
    </div>
  }

  <p-button
    [rounded]="true"
    styleClass="!p-1 !border-white !border"
    (click)="profilePopover.toggle($event)"
  >
    <div class="flex items-center gap-1">
      <p-avatar
        [label]="
          !hasUserAvatar()
            ? $safeNavigationMigration(userFullName()?.charAt(0))
            : null
        "
        [image]="hasUserAvatar() ? userAvatarUrl() : null"
        shape="circle"
        size="normal"
      />
      <svg-icon
        class="pointer-events-none"
        [src]="
          profilePopoverOpen
            ? 'assets/icons/general/chevron-up.svg'
            : 'assets/icons/general/chevron-down.svg'
        "
      />
    </div>
  </p-button>
</div>

<p-popover
  #profilePopover
  (onShow)="onProfilePopoverShow()"
  (onHide)="onProfilePopoverHide()"
>
  <div class="flex w-96 flex-col">
    <!-- user -->
    <div class="flex items-center gap-3">
      @if (layoutService.isMobile()) {
        <p-avatar
          [label]="
            !hasUserAvatar()
              ? $safeNavigationMigration(userFullName()?.charAt(0))
              : null
          "
          [image]="hasUserAvatar() ? userAvatarUrl() : null"
          shape="circle"
          size="xlarge"
        />
      } @else {
        <p-avatar
          [label]="
            !hasUserAvatar()
              ? $safeNavigationMigration(userFullName()?.charAt(0))
              : null
          "
          [image]="hasUserAvatar() ? userAvatarUrl() : null"
          shape="circle"
          size="large"
        />
      }
      <div class="flex flex-col gap-1">
        <h3 class="font-medium">
          {{ userFullName() }}
        </h3>
        <p class="text-sm text-slate-500">
          {{ company()?.name }}
        </p>
      </div>
    </div>

    @if (layoutService.isMobile()) {
      <!-- divider -->
      <hr class="my-2 border-slate-300" />

      <!-- menu -->
      <div class="flex flex-col gap-1">
        <!-- notifications -->
        <app-notifications-v2
          *agHasPermission="PermissionEnum.PagesDemo"
          layout="menu"
          [hasNextPage]="notificationsOrchestratorService.hasNextPage()"
          [isLoading]="notificationsOrchestratorService.loading()"
          [loadingMore]="notificationsOrchestratorService.loadingMore()"
          [notifications]="notificationsOrchestratorService.notifications()"
          [filteredNotificationsCount]="
            notificationsOrchestratorService.filteredNotificationsCount()
          "
          [totalNotificationsCount]="
            notificationsOrchestratorService.totalNotificationsCount()
          "
          [unreadNotificationsCount]="
            notificationsOrchestratorService.unreadNotificationsCount()
          "
          (notificationCountChange)="onNotificationCountChange($event)"
          (archiveAll)="
            notificationsOrchestratorService.onArchiveAllNotifications($event)
          "
          (archiveAllRead)="
            notificationsOrchestratorService.onArchiveAllReadNotifications(
              $event
            )
          "
          (archiveNotification)="
            notificationsOrchestratorService.onArchiveNotification($event)
          "
          (filterNotifications)="
            notificationsOrchestratorService.onFilterNotifications($event)
          "
          (loadMore)="notificationsOrchestratorService.loadMore()"
          (markAllAsRead)="
            notificationsOrchestratorService.onMarkAllAsRead($event)
          "
          (markNotificationAsRead)="
            notificationsOrchestratorService.onMarkNotificationAsRead($event)
          "
          (markNotificationAsUnread)="
            notificationsOrchestratorService.onMarkNotificationAsUnread($event)
          "
          (notificationClick)="
            notificationsOrchestratorService.onNotificationClick($event)
          "
        />

        <!-- alerts -->
        <app-alerts-menu
          *agHasPermission="PermissionEnum.PagesDemo"
          layout="menu"
          [alerts]="alertsOrchestratorService.alerts()"
          [filteredAlertsCount]="
            alertsOrchestratorService.filteredAlertsCount()
          "
          [hasNextPage]="alertsOrchestratorService.hasNextPage()"
          [isLoading]="alertsOrchestratorService.loading()"
          [loadingMore]="alertsOrchestratorService.loadingMore()"
          [totalAlertsCount]="alertsOrchestratorService.totalAlertsCount()"
          [unreadAlertsCount]="alertsOrchestratorService.unreadAlertsCount()"
          (alertsCountChange)="onAlertsCountChange($event)"
          (alertClick)="alertsOrchestratorService.onAlertClick($event)"
          (archiveAlert)="alertsOrchestratorService.onArchiveAlert($event)"
          (archiveAll)="alertsOrchestratorService.onArchiveAllAlerts($event)"
          (archiveAllRead)="
            alertsOrchestratorService.onArchiveAllReadAlerts($event)
          "
          (filterAlerts)="alertsOrchestratorService.onFilterAlerts($event)"
          (loadMore)="alertsOrchestratorService.loadMore()"
          (markAlertAsRead)="
            alertsOrchestratorService.onMarkAlertAsRead($event)
          "
          (markAlertAsUnread)="
            alertsOrchestratorService.onMarkAlertAsUnread($event)
          "
          (markAllAsRead)="alertsOrchestratorService.onMarkAllAsRead($event)"
        />

        <!-- packhouse connectivity -->
        <app-packhouse-connectivity layout="menu" />
      </div>
    }

    <!-- divider -->
    <hr class="my-2 border-slate-300" />

    <!-- menu -->
    <div class="flex flex-col gap-1">
      <p-button
        label="My profile"
        variant="text"
        severity="contrast"
        styleClass="w-full !justify-start"
        (click)="navService.navigateToMyProfile(); profilePopover.hide()"
      >
        <svg-icon src="assets/icons/general/user.svg" />
      </p-button>

      <!-- notifications -->
      <app-notifications
        layout="menu"
        (userFeedUnseenItemCountChange)="
          onUserFeedUnseenItemCountChange($event)
        "
      />

      <!-- support -->
      <app-support-menu layout="menu" />

      @if (layoutService.isMobile()) {
        <p-button
          label="Settings"
          variant="text"
          severity="contrast"
          styleClass="w-full !justify-start"
          (click)="navService.navigateToSettings(); profilePopover.hide()"
        >
          <svg-icon src="assets/icons/general/settings.svg" />
        </p-button>
      }
    </div>

    <!-- divider -->
    <hr class="my-2 border-slate-300" />
    <!-- logout -->
    <p-button
      label="Logout"
      variant="text"
      severity="contrast"
      styleClass="w-full !justify-start"
      (click)="onLogout($event)"
    >
      <svg-icon src="assets/icons/general/logout.svg" />
    </p-button>
  </div>
</p-popover>
